import CarouselBannersHome from 'components/Carousel/CarouselBannersHome';
import Logo from 'components/Logos/Logo';
import React from 'react';
import { Link } from 'react-router-dom';

const BreadCrumbBanners = ({ banners }) => {
  return (
    <React.Fragment>
      <div className="row mx-1 mx-sm-0 my-2">
        <div className="col-lg-3 align-self-center">
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <div className="col-lg-9">
          {banners && banners?.length > 0 && <CarouselBannersHome data={banners} />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default BreadCrumbBanners;
